import React, {useState} from 'react';

import {AttachmentFullscreen} from 'src/components/trigger-attachment/attachment-fullscreen';
import {AttachmentUpload} from 'src/components/trigger-attachment/attachment-upload';
import {MAX_ACTIVE_ATTACHMENTS_COUNT} from 'src/constants';
import {useUserRoles} from 'src/hooks/useUserRoles';
import {AttachmentPreview} from 'src/modules/event/event-trigger-attachment/attachment-preview/attachment-preview';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {Role} from 'src/openapi/models/Role';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import Carousel, {CarouselItem} from '@pb/kit-component-carousel';
import {Group, Item} from '@pb/kit-component-group';
import {
    HorizontalPositionElement,
    PushNotification,
    VerticalPositionElement,
} from '@pb/kit-component-push-notification';

type Props = {
    eventDetailInfo: EventDetailInfo,
    triggerAttachments: TriggerAttachment[],
    isUploading: boolean,
    onUploadFiles: (acceptedFiles: File[]) => void,
};

const NO_ATTACHMENTS_TEXT = 'No attachments';
const NOTIFICATION_CONFIG = {
    horizontal: HorizontalPositionElement.RIGHT,
    vertical: VerticalPositionElement.BOTTOM,
};

export const EventTriggerAttachmentView = (props: Props) => {
    const {
        eventDetailInfo,
        triggerAttachments,
        isUploading,
        onUploadFiles,
    } = props;

    const userRoles = useUserRoles();
    const [fullscreen, setFullscreen] = useState<TriggerAttachment | null>(null);

    const canAddAttachment = userRoles.includes(Role.ROLE_UDEDT_ADMIN) &&
        triggerAttachments.length < MAX_ACTIVE_ATTACHMENTS_COUNT;

    return (
        <PushNotification anchorOrigin={NOTIFICATION_CONFIG}>
            <Group direction="v" gap="xxs" style={{height: '12rem', width: '100%'}}>
                <strong>Attachments:</strong>
                {canAddAttachment || triggerAttachments.length > 0 ? (
                    <Carousel key={isUploading} slidesGap={5}>
                        {triggerAttachments.map(attachment => (
                            <CarouselItem id={attachment.name} key={attachment.name}>
                                <AttachmentPreview
                                    eventId={eventDetailInfo.id}
                                    attachment={attachment}
                                    setFullscreen={setFullscreen}
                                />
                            </CarouselItem>
                        ))}
                        {canAddAttachment ? (
                            <CarouselItem id="file-attachment">
                                <AttachmentUpload
                                    isUploading={isUploading}
                                    onUploadFiles={onUploadFiles}
                                />
                            </CarouselItem>
                        ) : null}
                    </Carousel>
                ) : (
                    <Item>{NO_ATTACHMENTS_TEXT}</Item>
                )}
                <AttachmentFullscreen
                    attachment={fullscreen}
                    setFullscreen={setFullscreen}
                />
            </Group>
        </PushNotification>
    );
};
